import "./Footer.css";
import Category from "./Category";

const Footer = function (props) {
    const obj = props.items.reduce(function (temp, item) {
        if (!temp[item.MODFooterCategory]) temp[item.MODFooterCategory] = []
        temp[item.MODFooterCategory].push(item);
        return temp;
    }, Object.create(null));
    let cat = Object.keys(obj).sort().map((key,index) => {
        return <Category title={key.split(":")[1]} items={obj[key]}  key={"Footer_"+index}/>;
    })
    return (
      
            <ul className="row footerCont no-gutters">
                {cat}
            </ul>
            
        
    );

}
export default Footer;
